import logoSmImg from "@images/gamesPage/1x/49aa.png"
import logoImg from "@images/gamesPage/41aa.png"
import award1Img from "@images/gamesPage/42aa.png"
import award2Img from "@images/gamesPage/43aa.png"
import SideAnimationContainer from "@src/components/sideAnimationContainer"
import { useAppContext } from "@src/context"
import classnames from "@src/utils/classnames"
import React from "react"
import * as styles from "./header.module.scss"

const Header = React.memo((props) => {
  const { renderItem } = useAppContext()
  return (
    <>
      <div className={classnames("container0", styles.infoContainer)}>
        <div className={styles.head}>{renderItem(logoImg, logoSmImg)}</div>
        <div className={classnames("intro", styles.intro)}>
          <div className={classnames("intro_body", styles.introBody)}>
            <h2>线上试玩 & 评选会</h2>
            <div>
              <p>
                经过为期一个月的时间，这次活动收到了百余款游戏，我们决定将这些游戏整合在一起，并开启「线上试玩&评选会」
              </p>
              <p>
                我们邀请各位开发者和玩家们一起来体验一下这些游戏，欢迎在游戏下方留下你的游戏体验。如果遇到你喜欢的游戏，可以给游戏点赞，最后我们将依据获赞数，来选出以下奖项：
              </p>
            </div>
          </div>
        </div>
      </div>
      <SideAnimationContainer direction="left">
        <div className="container">
          <div className={styles.awards}>
            <div>
              <img src={award1Img} alt="award" />
            </div>
            <div>
              <img src={award2Img} alt="award" />
            </div>
          </div>
        </div>
      </SideAnimationContainer>
    </>
  )
})

Header.displayName = "header"
export default Header
